import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IResourcesCustomFilterFieldsFragment = {
  id?: any | null
  createdAt?: any | null
  updatedAt?: any | null
  version?: number | null
  projectId: any
  resourceTypeId: string
  name: string
  userId?: any | null
  isPublic: boolean
  defaultForUsers?: Array<any | null> | null
  groupBy?: string | null
  filtersByFilterType?: Array<{
    type?: string | null
    values?: Array<string | null> | null
  } | null> | null
}

export type IGetResourcesCustomFiltersByProjectQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  resourceTypeId: Types.Scalars['String']['input']
}>

export type IGetResourcesCustomFiltersByProjectQuery = {
  resourcesCustomFilters?: {
    data: Array<{
      id?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      version?: number | null
      projectId: any
      resourceTypeId: string
      name: string
      userId?: any | null
      isPublic: boolean
      defaultForUsers?: Array<any | null> | null
      groupBy?: string | null
      filtersByFilterType?: Array<{
        type?: string | null
        values?: Array<string | null> | null
      } | null> | null
    }>
  } | null
}

export type ISaveResourcesCustomFilterMutationVariables = Types.Exact<{
  filter: Types.IResourcesCustomFilterInput
}>

export type ISaveResourcesCustomFilterMutation = {
  saveResourcesCustomFilter?: {
    id?: any | null
    createdAt?: any | null
    updatedAt?: any | null
    version?: number | null
    projectId: any
    resourceTypeId: string
    name: string
    userId?: any | null
    isPublic: boolean
    defaultForUsers?: Array<any | null> | null
    groupBy?: string | null
    filtersByFilterType?: Array<{
      type?: string | null
      values?: Array<string | null> | null
    } | null> | null
  } | null
}

export type IDeleteResourcesCustomFilterMutationVariables = Types.Exact<{
  filterId: Types.Scalars['ObjectId']['input']
}>

export type IDeleteResourcesCustomFilterMutation = {
  deleteResourcesCustomFilter?: boolean | null
}

export const ResourcesCustomFilterFieldsFragmentDoc = gql`
  fragment ResourcesCustomFilterFields on ResourcesCustomFilter {
    id
    createdAt
    updatedAt
    version
    projectId
    resourceTypeId
    name
    userId
    isPublic
    filtersByFilterType {
      type
      values
    }
    defaultForUsers
    groupBy
  }
`
export const GetResourcesCustomFiltersByProjectDocument = gql`
  query GetResourcesCustomFiltersByProject(
    $projectId: ObjectId!
    $resourceTypeId: String!
  ) {
    resourcesCustomFilters(
      limit: 1000000
      projectId: $projectId
      resourceTypeId: $resourceTypeId
    ) {
      data {
        ...ResourcesCustomFilterFields
      }
    }
  }
  ${ResourcesCustomFilterFieldsFragmentDoc}
`

/**
 * __useGetResourcesCustomFiltersByProjectQuery__
 *
 * To run a query within a React component, call `useGetResourcesCustomFiltersByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourcesCustomFiltersByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourcesCustomFiltersByProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      resourceTypeId: // value for 'resourceTypeId'
 *   },
 * });
 */
export function useGetResourcesCustomFiltersByProjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetResourcesCustomFiltersByProjectQuery,
    IGetResourcesCustomFiltersByProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetResourcesCustomFiltersByProjectQuery,
    IGetResourcesCustomFiltersByProjectQueryVariables
  >(GetResourcesCustomFiltersByProjectDocument, options)
}
export function useGetResourcesCustomFiltersByProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetResourcesCustomFiltersByProjectQuery,
    IGetResourcesCustomFiltersByProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetResourcesCustomFiltersByProjectQuery,
    IGetResourcesCustomFiltersByProjectQueryVariables
  >(GetResourcesCustomFiltersByProjectDocument, options)
}
export type GetResourcesCustomFiltersByProjectQueryHookResult = ReturnType<
  typeof useGetResourcesCustomFiltersByProjectQuery
>
export type GetResourcesCustomFiltersByProjectLazyQueryHookResult = ReturnType<
  typeof useGetResourcesCustomFiltersByProjectLazyQuery
>
export type GetResourcesCustomFiltersByProjectQueryResult = Apollo.QueryResult<
  IGetResourcesCustomFiltersByProjectQuery,
  IGetResourcesCustomFiltersByProjectQueryVariables
>
export const SaveResourcesCustomFilterDocument = gql`
  mutation SaveResourcesCustomFilter($filter: ResourcesCustomFilterInput!) {
    saveResourcesCustomFilter(resourcesCustomFilter: $filter) {
      ...ResourcesCustomFilterFields
    }
  }
  ${ResourcesCustomFilterFieldsFragmentDoc}
`
export type ISaveResourcesCustomFilterMutationFn = Apollo.MutationFunction<
  ISaveResourcesCustomFilterMutation,
  ISaveResourcesCustomFilterMutationVariables
>

/**
 * __useSaveResourcesCustomFilterMutation__
 *
 * To run a mutation, you first call `useSaveResourcesCustomFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveResourcesCustomFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveResourcesCustomFilterMutation, { data, loading, error }] = useSaveResourcesCustomFilterMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSaveResourcesCustomFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveResourcesCustomFilterMutation,
    ISaveResourcesCustomFilterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveResourcesCustomFilterMutation,
    ISaveResourcesCustomFilterMutationVariables
  >(SaveResourcesCustomFilterDocument, options)
}
export type SaveResourcesCustomFilterMutationHookResult = ReturnType<
  typeof useSaveResourcesCustomFilterMutation
>
export type SaveResourcesCustomFilterMutationResult =
  Apollo.MutationResult<ISaveResourcesCustomFilterMutation>
export type SaveResourcesCustomFilterMutationOptions =
  Apollo.BaseMutationOptions<
    ISaveResourcesCustomFilterMutation,
    ISaveResourcesCustomFilterMutationVariables
  >
export const DeleteResourcesCustomFilterDocument = gql`
  mutation DeleteResourcesCustomFilter($filterId: ObjectId!) {
    deleteResourcesCustomFilter(id: $filterId)
  }
`
export type IDeleteResourcesCustomFilterMutationFn = Apollo.MutationFunction<
  IDeleteResourcesCustomFilterMutation,
  IDeleteResourcesCustomFilterMutationVariables
>

/**
 * __useDeleteResourcesCustomFilterMutation__
 *
 * To run a mutation, you first call `useDeleteResourcesCustomFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourcesCustomFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourcesCustomFilterMutation, { data, loading, error }] = useDeleteResourcesCustomFilterMutation({
 *   variables: {
 *      filterId: // value for 'filterId'
 *   },
 * });
 */
export function useDeleteResourcesCustomFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteResourcesCustomFilterMutation,
    IDeleteResourcesCustomFilterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteResourcesCustomFilterMutation,
    IDeleteResourcesCustomFilterMutationVariables
  >(DeleteResourcesCustomFilterDocument, options)
}
export type DeleteResourcesCustomFilterMutationHookResult = ReturnType<
  typeof useDeleteResourcesCustomFilterMutation
>
export type DeleteResourcesCustomFilterMutationResult =
  Apollo.MutationResult<IDeleteResourcesCustomFilterMutation>
export type DeleteResourcesCustomFilterMutationOptions =
  Apollo.BaseMutationOptions<
    IDeleteResourcesCustomFilterMutation,
    IDeleteResourcesCustomFilterMutationVariables
  >
